import { ICompanyImage } from "@/types/company_image";

export class CompanyImage implements ICompanyImage {
  public id = 0;
  public company_id = 0;
  public hash = "";
  public extension = "";
  public mime_type = "";
  public name = "";
  public created_at = "";
  public updated_at = "";
  public url = "";
}
